// src/components/ui/ApprovalWorkflowSection.jsx
import React from 'react';
import { 
  Box,
  Typography,
  Paper,
  List,
  Button,
  useTheme,
  alpha
} from '@mui/material';
import ApprovalStepItem from './ApprovalStepItem';

/**
 * Reusable approval workflow section component
 * @param {Object} props
 * @param {Object} props.workflow - The approval workflow object
 * @param {boolean} props.canApprove - Whether the user can approve content
 * @param {Function} props.onSetupWorkflow - Function to call to set up workflow
 * @param {string} props.contentId - ID of the content
 */
const ApprovalWorkflowSection = ({ 
  workflow, 
  canApprove, 
  onSetupWorkflow, 
  contentId 
}) => {
  const theme = useTheme();
  
  const hasWorkflow = workflow && workflow.steps && workflow.steps.length > 0;
  
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Approval Status
      </Typography>
      
      {!hasWorkflow ? (
        <Paper sx={{ p: 3 }}>
          <Typography variant="body1" color="textSecondary" align="center">
            No approval workflow has been defined for this content.
          </Typography>
          
          {canApprove && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={onSetupWorkflow}
              >
                Set Up Approval Workflow
              </Button>
            </Box>
          )}
        </Paper>
      ) : (
        <Box>
          <List>
            {workflow.steps.map((step, index) => (
              <ApprovalStepItem key={index} step={step} />
            ))}
          </List>
          
          {workflow.isCompleted ? (
            <Box sx={{ p: 2, bgcolor: alpha(theme.palette.success.main, 0.1), borderRadius: 1 }}>
              <Typography variant="subtitle2" color="success.main">
                Approval workflow completed
              </Typography>
            </Box>
          ) : (
            <Box sx={{ p: 2, bgcolor: alpha(theme.palette.info.main, 0.1), borderRadius: 1 }}>
              <Typography variant="subtitle2" color="info.main">
                Approval workflow in progress
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ApprovalWorkflowSection;
